// src/components/layout/LayoutSEO.tsx
import React from 'react';
import { useLocation } from 'react-router-dom';
import { 
  HomeSEO, 
  AboutSEO, 
  PricingSEO, 
  ContactSEO, 
  DocumentationSEO, 
  PageSEO 
} from '../../pages/SEOHelpers';

export const LayoutSEO: React.FC = () => {
  const location = useLocation();
  const path = location.pathname;

  // Match paths to appropriate SEO components
  if (path === '/' || path === '/home') {
    return <HomeSEO />;
  }
  
  if (path === '/about') {
    return <AboutSEO />;
  }
  
  if (path === '/pricing') {
    return <PricingSEO />;
  }
  
  if (path === '/contact') {
    return <ContactSEO />;
  }
  
  if (path.startsWith('/docs') || path === '/documentation') {
    return <DocumentationSEO />;
  }
  
  // Special handling for documentation pages
  if (path.startsWith('/docs/')) {
    const docPathSegment = path.split('/').filter(Boolean)[1] || '';
    const docTitle = docPathSegment
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
      
    return (
      <PageSEO 
        title={`${docTitle} | Documentation`}
        description={`Learn about ${docTitle} in Newsroom's comprehensive documentation. Get detailed guides and tutorials for this feature.`}
        canonical={`https://news-room.ca${path}`}
        pageType="docs"
        keywords={[
          `${docTitle.toLowerCase()} guide`,
          `newsroom ${docPathSegment}`,
          `financial AI ${docPathSegment.replace(/-/g, ' ')}`,
          `stock research ${docPathSegment.replace(/-/g, ' ')}`
        ]}
      />
    );
  }
  
  // For other pages, use a generic SEO with path-based title
  const pathSegments = path.split('/').filter(Boolean);
  const title = pathSegments.length > 0 
    ? pathSegments[pathSegments.length - 1]
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
    : 'Page';
    
  return (
    <PageSEO 
      title={title} 
      description={`Newsroom - ${title} page information and resources for AI-powered stock research and market intelligence`}
      canonical={`https://news-room.ca${path}`}
      keywords={[
        `${title.toLowerCase()}`,
        `newsroom ${title.toLowerCase()}`,
        "AI stock research",
        "market intelligence"
      ]}
    />
  );
};

export default LayoutSEO;
